module.exports = __webpack_public_path__ + "static/media/alert-circle-red.c2846d26.svg";